// Action-button visibility rules that only apply while a permit is sitting at
// P0251 (REQUESTER_INFORMATION) - the "waiting for requester to add info"
// status. Kept separate from PermitRequestPage.tsx so future P0251-specific
// button rules land here instead of growing that file further.

export interface RequesterInfoActionVisibilityInput {
  isRequesterInformationState: boolean
  isExcavationPermit: boolean
}

export interface RequesterInfoActionVisibility {
  // Excavation permits at P0251 only offer the resubmit action - reviewers
  // shouldn't see ไม่อนุมัติ/ส่งกลับ, and the requester shouldn't see
  // บันทึกร่าง/ส่งอนุมัติ. ยกเลิกเอกสาร stays visible for every permit type.
  hideReviewActions: boolean
  hideSaveButton: boolean
  hideSubmitButton: boolean
}

export const getRequesterInfoActionVisibility = ({
  isRequesterInformationState,
  isExcavationPermit,
}: RequesterInfoActionVisibilityInput): RequesterInfoActionVisibility => {
  const hideExcavationInfoActions = isRequesterInformationState && isExcavationPermit
  return {
    hideReviewActions: hideExcavationInfoActions,
    hideSaveButton: hideExcavationInfoActions,
    hideSubmitButton: hideExcavationInfoActions,
  }
}
